export const CheckResource = {
  "CheckSuccess": "語法校驗通過！",
  "ConfirmWhenError": "可能存在的語法問題如下,是否仍保存？",
  "EsprimaSplit": "】-->【",
  "ErrorText": "在第{0}行,第{1}列出現錯誤,原因是【{2}】。請檢查紅色底線以及附近語法是否正常！",
  "ErrorDetail": "存在{0}個异常,詳細資訊如下:",
  "Error": "异常",
  "ContextNotSet": "在第{0}行,上下文變數-->未設定",
  "SessionNotSet": "在第{0}行,會話變數-->未設定",
  "ContextNotExist": "在第{0}行,上下文變數【{1}】-->不存在",
  "SessionNotExist": "在第{0}行,會話變數【{1}】-->不存在",
  "ParamIllegal": "在第{0}行,函數【{1}】的參數不合法,請檢查！",
  "ParamArrayIllegal": "在第{0}行,函數【{1}】的數組類型參數不合法,請檢查！",
  "ParamNumberWithZero": "在第{0}行,函數【{1}】的參數數量不匹配,需要0個或{2}個,實際{3}個,請檢查！",
  "ParamNumber": "在第{0}行,函數【{1}】的參數數量不匹配,需要{2}個,實際{3}個,請檢查！",
  "SimpleNoProperty": "在第{0}行,普通内容【{1}】沒有子内容",
  "ChildNoProperty": "在第{0}行,子錶【{1}】沒有内容【{2}】",
  "PropertyNoProperty": "在第{0}行,欄位【{1}】沒有内容【{2}】",
  "AddTwoManyParameters": "在第{0}行，函數【{1}】的參數數量過多，請檢查！",
  "Token": "意外的記號",
  "ILLEGAL": "非法的識別字",
  "EndOfInpur": "意外的結束標識"
}